import PopupDeleteRestoreContact from './PopupDeleteRestoreContact';

export default PopupDeleteRestoreContact;
